import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
@Component({
  selector: 'app-job-title-structure',
  templateUrl: './job-title-structure.component.html',
  styleUrls: ['./job-title-structure.component.scss']
})
export class JobTitleStructureComponent implements OnInit {
  button={}
  customDataSource: any;
  managemetList:{}[]=[]
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(public gt:genericCustomStoreService,public translate:TranslateService,public Objects:ObjectsService,public _publicSettingService:publicSettingService,public router:Router,public route:ActivatedRoute) {
    this.gt.seturl('JobTitleStructure')
    gt.submit();
    this.customDataSource = gt.customDataSource;
    this.button=Objects.button;
    gt.getdropdowndata("Management").subscribe((res:[])=>this.managemetList=res)
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });

  }

  ngOnInit(): void { }

  jobtitle(e:any){            
  this.router.navigate(['../add-edit-jobTitleStructure'],{relativeTo:this.route}) 
  this._publicSettingService.$JOB_TITLE_ID.next(e.key?e.key:0)
  }
  addrowfun(name:string){
    return this.gt.addrow(name)
  }
}
